import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { signInWithEmailAndPassword } from 'firebase/auth'
import { auth } from '../../firebase/firebase'
import { useAuth } from '../../contexts/AuthContext'
import { checkLockout, recordFailedAttempt, clearAttempts } from '../../firebase/loginLockout'

const AdminLogin = () => {
  const { currentUser } = useAuth()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [lockedMinutes, setLockedMinutes] = useState(null)

  if (currentUser) {
    navigate('/admin/pages', { replace: true })
    return null
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLockedMinutes(null)
    setLoading(true)

    try {
      const lockout = await checkLockout(email)
      if (lockout.locked) {
        setLockedMinutes(lockout.remainingMinutes)
        return
      }

      await signInWithEmailAndPassword(auth, email, password)
      await clearAttempts(email)
      navigate('/admin/pages', { replace: true })
    } catch (err) {
      const attempt = await recordFailedAttempt(email)
      if (attempt.isNowLocked) {
        setLockedMinutes(15)
      } else {
        setError(`Невірний email або пароль. Залишилось спроб: ${attempt.remainingAttempts}`)
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={s.page}>
      <div style={s.panel}>
        <div style={s.logoMark}>✦</div>
        <h1 style={s.title}>Адмін-панель</h1>
        <p style={s.subtitle}>Храм Спасіння · Вхід для адміністраторів</p>

        {lockedMinutes !== null && (
          <div style={s.error}>
            <span style={s.errorIcon}>🔒</span> Забагато невдалих спроб. Спробуйте знову через {lockedMinutes} хв.
          </div>
        )}

        {error && lockedMinutes === null && (
          <div style={s.error}>
            <span style={s.errorIcon}>⚠</span> {error}
          </div>
        )}

        <form onSubmit={handleSubmit} style={s.form}>
          <div style={s.field}>
            <label style={s.label}>Email</label>
            <input
              type='email'
              value={email}
              onChange={e => setEmail(e.target.value)}
              style={s.input}
              placeholder='admin@church.com'
              required
              autoFocus
              disabled={lockedMinutes !== null}
            />
          </div>

          <div style={s.field}>
            <label style={s.label}>Пароль</label>
            <input
              type='password'
              value={password}
              onChange={e => setPassword(e.target.value)}
              style={s.input}
              placeholder='••••••••'
              required
              disabled={lockedMinutes !== null}
            />
          </div>

          <button type='submit' disabled={loading || lockedMinutes !== null} style={s.btn}>
            {loading ? 'Вхід…' : lockedMinutes !== null ? 'Заблоковано' : 'Увійти'}
          </button>
        </form>
      </div>
    </div>
  )
}

const s = {
  page: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f5ede3 0%, #ede0d0 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: '"Segoe UI", system-ui, sans-serif',
    padding: '20px',
  },
  panel: {
    background: '#fff',
    borderRadius: '16px',
    padding: '48px 40px 44px',
    width: '100%',
    maxWidth: '560px',
    boxShadow: '0 8px 40px rgba(92,61,46,0.12)',
    textAlign: 'center',
  },
  logoMark: {
    fontSize: '28px',
    color: '#c4986a',
    marginBottom: '16px',
    display: 'block',
  },
  title: {
    margin: '0 0 8px',
    fontSize: '26px',
    fontWeight: '700',
    color: '#2d1f14',
    letterSpacing: '-0.3px',
  },
  subtitle: {
    margin: '0 0 36px',
    fontSize: '14px',
    color: '#9a7c63',
  },
  form: {
    textAlign: 'left',
    width: '100%',
    margin: 0,
    marginTop: 0,
    padding: 0,
    border: 'none',
    borderRadius: 0,
    background: 'none',
    boxShadow: 'none',
    display: 'block',
  },
  field: {
    marginBottom: '22px',
  },
  label: {
    display: 'block',
    fontSize: '13px',
    fontWeight: '600',
    color: '#6b4a32',
    marginBottom: '8px',
    letterSpacing: '0.3px',
  },
  input: {
    width: '100%',
    padding: '13px 16px',
    border: '1.5px solid #e8d8c8',
    borderRadius: '8px',
    fontSize: '15px',
    color: '#2d1f14',
    background: '#fdfaf7',
    boxSizing: 'border-box',
    outline: 'none',
    transition: 'border-color 0.2s',
    fontFamily: 'inherit',
  },
  btn: {
    width: '100%',
    padding: '14px',
    background: 'linear-gradient(135deg, #6b4a32, #8b6044)',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
    marginTop: '8px',
    letterSpacing: '0.3px',
    fontFamily: 'inherit',
  },
  error: {
    background: '#fdf2f2',
    border: '1px solid #f5c6c6',
    color: '#a33',
    padding: '12px 16px',
    borderRadius: '8px',
    fontSize: '14px',
    marginBottom: '24px',
    textAlign: 'left',
  },
  errorIcon: {
    marginRight: '6px',
  },
}

export default AdminLogin
